export default function MySQL_MIN() {
  return (
    <div>
      <h2>MySQL_MIN</h2>    </div>
  );
}